<div id="{{position}}" class="position-relative"
  [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
  [ngClass]="activatePadding?'header-padding-top':''">
  <div [attr.data-aos]="allElementAnimation ? allElementAnimation : null"
    [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }">
    <div class="feature-light-bg "
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }">
      <div class="features-row-container">
        <div *ngIf="title" class="feature-title pt-40" [attr.data-aos]="textAnimation ? textAnimation : null">
          <h1 class="center mb-60" [ngClass]="[titleSize]"
            [ngStyle]="{ 'font-family': titleFontFamily ? titleFontFamilyName : '' ,'color': titleColor?titleColor:textColor,'font-weight':fontWeight }">
            {{title}}</h1>
        </div>
        <ng-container *ngFor="let feature of features; let featureIndex = index">
          <div [attr.data-aos]="itemsAnimation ? itemsAnimation : null" [ngClass]="classFeature" class="feature-row"
            fxLayoutAlign="start center" class="cta-form-container">
            <div [fxFlex]="feature.width + 'px'" fxFlex.gt-md="600px" fxFlex.xs="250px" fxFlex.sm="100%"
              [fxFlexOrder]="(featureIndex % 2 == 0 || featureIndex === 0) ? 1 : 2" class="feature-picture">
              <div class="image-container" [ngClass]="{
                'text-right': (featureIndex % 2 == 0)
              }">
                <img [ngStyle]="{'border-radius': feature.borderRadius+'px'}" class="feature-img feature-row-img" [alt]="feature.title"
                  [src]="feature.image ? feature.image : 'https://via.placeholder.com/500/6f777b/fafafa/?text=Image'">
              </div>
            </div>
            <div fxFlex fxFlex.gt-md="600px" [fxFlexOrder]="(featureIndex % 2 == 0 || featureIndex === 0) ? 2 : 1"
              class="feature-text" [ngClass]="{
              'text-center': feature.textAlign == 'center',
              'text-left': feature.textAlign == 'left',
              'text-right': feature.textAlign == 'near the image' && (featureIndex % 2 != 0)
            }">
              <h1 [ngStyle]="{ 'font-family': getTitleFontFamilyName(feature.titleFontFamily) ,'color': feature.titleColor?feature.titleColor:feature.textColor }"> {{ feature.title }}
              </h1>
              <p [ngStyle]="{ 'color': feature.textColor }" [innerHtml]=" feature.text | safeHtml">
              </p>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>